// extracted by mini-css-extract-plugin
export default {"board":"Board_board__PSzaK","row":"Board_row__8lW6I"};